import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import tw from "twin.macro";

import Hero from "../hero";
import Tabs from "../tabs";
import AppLink from "../app-link.js";
import { Container, SubHeading, Paragraph } from "../section";
import UpdatesContext from "./context";

const PageContainer = tw.div`my-8 container mx-4 sm:mx-auto w-auto`;
const DetailsTable = tw.ul`bg-gray-50 p-4 text-sm mb-4`;
const DetailsRow = tw.li`space-x-2`;
const DetailsHeading = tw.strong`w-32 inline-block font-normal text-gray-700`;
const DetailsContent = tw.span``;

const FundingContent = ({ archived }) => {
  const updatesContext = useContext(UpdatesContext);
  const { loading, error, getFunding, funding } = updatesContext;

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "news-banner.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const tabs = [
    { label: "News", active: false, to: "/updates" },
    { label: "Newsletters", active: false, to: "/updates/newsletters" },
    { label: "Meetings and Events", active: false, to: "/updates/events" },
    {
      label: "Funding Opportunities",
      active: true,
      to: "/updates/funding-opportunities"
    }
  ];

  useEffect(() => {
    getFunding();
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <Hero imgQuery={data.file.childImageSharp.fluid}>
        Funding Opportunities
      </Hero>
      <div tw="bg-gray-100">
        <div tw="container mx-4 sm:mx-auto">
          <Tabs tabs={tabs} />
        </div>
      </div>
      <PageContainer>
        {archived && (
          <AppLink to="/updates/funding-opportunities">
            Back to Active Funding
          </AppLink>
        )}
        {loading
          ? "Loading..."
          : error
          ? error
          : funding
              .filter(node => (archived ? node.archived : !node.archived))
              .map((node, i) => (
                <Container key={`grant-${i}`}>
                  <SubHeading>{node.title}</SubHeading>
                  <DetailsTable>
                    {node.id && (
                      <DetailsRow>
                        <DetailsHeading>ID</DetailsHeading>
                        <DetailsContent>{node.id}</DetailsContent>
                      </DetailsRow>
                    )}
                    <DetailsRow>
                      <DetailsHeading>Posted</DetailsHeading>
                      <DetailsContent>{node.posted}</DetailsContent>
                    </DetailsRow>
                    {node.intentDue && (
                      <DetailsRow>
                        <DetailsHeading>Letter of Intent Due</DetailsHeading>
                        <DetailsContent>{node.intentDue}</DetailsContent>
                      </DetailsRow>
                    )}
                    <DetailsRow>
                      <DetailsHeading>Submission Due</DetailsHeading>
                      <DetailsContent>{node.deadline}</DetailsContent>
                    </DetailsRow>
                    <DetailsRow>
                      <DetailsHeading>More Information</DetailsHeading>
                      <DetailsContent>
                        <AppLink href={node.url}>{node.url}</AppLink>
                      </DetailsContent>
                    </DetailsRow>
                  </DetailsTable>
                  <Paragraph>{node.description}</Paragraph>
                </Container>
              ))}
        {!archived && (
          <AppLink to="/updates/funding-opportunities/archive">
            Funding Archive
          </AppLink>
        )}
      </PageContainer>
    </>
  );
};

FundingContent.propTypes = {
  archived: PropTypes.bool
};

FundingContent.defaultProps = {
  archived: false
};

export default FundingContent;
